import { Component } from '@angular/core';

@Component({
  selector: 'payarc-table',
  template: `
    <div class="pa-table-wrap">
      <table class="pa-table">
        <ng-content></ng-content>
      </table>
    </div>`,
  standalone: false
})
export class PayarcTableComponent {}
